import { render } from "./AccelCard.vue?vue&type=template&id=b697e10a"
import script from "./AccelCard.vue?vue&type=script&lang=js"
export * from "./AccelCard.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__